import React from "react";
import { CV } from "../components/cv";
import MarkusRImg from "@/assets/images/markus-r.png";

export default function CVMarkusRytterkull() {
  React.useEffect(() => {
    document.title = "BoldBrave CV - Markus Rytterkull";
  }, []);

  return (
    <CV
      name="Markus Rytterkull"
      title="Multifunctional Software Developer"
      subtitle="20+ years of .NET and Episerver/Optimizely expertise — background at Avensia and Ericsson"
      photo={MarkusRImg}
      summary="Multifunctional software developer and trainer with 20+ years in web development on Microsoft platforms. Specializes in .NET, Episerver/Optimizely, e-commerce and legacy modernization. Known for solving tricky problems, mentoring juniors, and getting legacy code back in shape."
      skills={{
        "Languages": ["C#", ".NET", "JavaScript", "CSS", "HTML"],
        "Platforms": ["Episerver", "Optimizely", "Umbraco"],
        "Backend": ["ASP.NET", "SQL Server", "E-commerce"],
        "Methods": ["Scrum", "Architecture", "Training & Mentoring"],
      }}
      experience={[
        {
          role: "Multifunctional Software Developer",
          company: "BoldBrave · Freelance",
          period: "Jun 2020 – Present",
          description:
            "Freelance web development on .NET and Episerver/Optimizely platforms, solving complex problems and modernizing legacy applications.",
          highlights: [
            "Fitness24Seven (2022 – Present) — backend and platform development on the Fitness24Seven .NET stack",
          ],
        },
        {
          role: "Senior Web Developer",
          company: "Kod&Knåd",
          period: "Jan 2016 – Present",
          description:
            "Freelance smart & social web developer (ASP.NET/Episerver), combined with work as a massage therapist. Same web development work as previously done through mrTechnology, now under one firm — see Beyond Code below for the wellness side of the business.",
        },
        {
          role: "Trainer / Developer / Owner",
          company: "mrTechnology",
          period: "2011 – Jun 2020",
          description:
            "Freelance consultant within ASP.NET, Episerver, e-commerce and other .NET technologies. Specialist in solving the odd problem that only appears now and then, modernizing legacy code, integrations, advanced troubleshooting and training junior developers — on the client's terms and only the hours actually needed.",
          highlights: [
            "Helped clients start new projects with proper architecture and mentored junior teams",
            "Modernized and refactored legacy .NET applications",
            "Delivered training in .NET and system development for course providers and clients",
          ],
        },
        {
          role: "Developer / Architect",
          company: "Avensia",
          period: "Feb 2006 – Feb 2011",
          description:
            "System developer, architect and Scrum Master within .NET, web development, Windows Mobile and Speech Server. Worked on projects across multiple industries and delivered developer training.",
        },
        {
          role: "Developer",
          company: "Programmera",
          period: "1998 – 2000",
          description:
            "Software development.",
        },
        {
          role: "Performance Engineer",
          company: "Ericsson Radio Systems",
          period: "1996 – 1998",
          description:
            "Performance engineering for radio systems at Ericsson.",
        },
      ]}
      education={[
        {
          degree: "Engineering",
          institution: "The Faculty of Engineering at Lund University (LTH)",
          year: "1991 – 1996",
        },
      ]}
      otherActivities={{
        title: "Beyond Code",
        description:
          "Alongside his developer career, Markus has run CarambaSyd (May 2011 – Jun 2020) as a corporate wellness expert, massage therapist and training coach — delivering on-site massage, practical health coaching, lectures and events at customer premises. He brings the same philosophy into his work today: healthy life, healthy code.",
      }}
    />
  );
}
